import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { ILogin } from "../../../models/Login";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { ShowPurchaseOrder } from "../showPurchaseOrder";
import { Card } from "primereact/card";
import { SubVendorDetails } from "./details/Details";
import { ShowTimesheet } from "../showTimesheet";
import { ShowDocuments } from "../showDocuments";



export const SubvendorDashboard = () => {
    const [modelE, setModelE] = useState<boolean>(false);
    const [modelF, setModelF] = useState<boolean>(false);
    const [modelG, setModelG] = useState<boolean>(false);
    const [modelH, setModelH] = useState<boolean>(false);
    // const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IPurchaseOrder>, loading: boolean });


    const navigate = useNavigate();

    // const loadPOList = async () => {
    //     let externalUserFilter = "";
    //     if (loginObj.user_Type === 3) {
    //         externalUserFilter = `&subvendorUser=${loginObj.sub_Vendor_ID}&userType=${loginObj.user_Type}`;
    //     }
    //     const response = await Fetch("vwPODetailsExternalUser", "GET", null, `filter=${JSON.stringify({})}` + externalUserFilter, null);
    //     if (response) {
    //         const data: Array<IPurchaseOrder> = await response.json();
    //         setTableData({ tableData: data, loading: false });
    //     }
    // }

    const goToDashboard = () => {
        navigate("/dashboard");
    };

    useEffect(() => {
        // loadPOList();
    }, []);
    return (
        <>
            <SubVendorDetails />
            <div className="button-container">
                <Button label="Show Purchase Orders" onClick={() =>  navigate("/showPurchase")}/>
                <Button label="Show Pending Timesheets" onClick={() => navigate("/timesheet")} />
                <Button label="Show My Invoices" onClick={() => navigate("/subVendorInvoices")} />
                <Button label="Show Documents" onClick={() => navigate("/showDocuments")} />
            </div>
            {/* {modelE && <Dialog visible={modelE} style={{ width: "65vw" }} header={<p className="w-full flex justify-content-between pr-2"><span>Show My Projects</span><span></span><Button className="w-12rem" label="Go to Dashboard" onClick={goToDashboard} icon="pi pi-arrow-left" /></p>} modal className="p-fluid" onHide={() => setModelE(prev => prev = false)} maximized={true}>
                <ShowPurchaseOrder />
                
            </Dialog>}
            {modelF && <Dialog visible={modelF} style={{ width: "65vw" }} header={<p className="w-full flex justify-content-between pr-2"><span>Show Pending Timesheet</span><span></span><Button className="w-12rem" label="Go to Dashboard" onClick={goToDashboard} icon="pi pi-arrow-left" /></p>} modal className="p-fluid" onHide={() => setModelF(prev => prev = false)} maximized={true}>
                <ShowTimesheet isConsultant={false} is_Create={true} is_Delete={false} is_Update={true} is_Export={false} is_View={true} po={{}} subVendor={true} />
            </Dialog>}
            {modelG && <Dialog visible={modelG} style={{ width: "65vw" }} header={<p className="w-full flex justify-content-between pr-2"><span>Show My Invoices</span><span></span><Button className="w-12rem" label="Go to Dashboard" onClick={goToDashboard} icon="pi pi-arrow-left" /></p>} modal className="p-fluid" onHide={() => setModelG(prev => prev = false)} maximized={true}>
                {tableData.tableData.length > 0 && tableData.tableData.map(e => <SubVendorInvoices poID={e} />)}
            </Dialog>}
            {modelH && <Dialog visible={modelH} style={{ width: "65vw" }} header={<p className="w-full flex justify-content-between pr-2"><span>Show My Documents</span><span></span><Button className="w-12rem" label="Go to Dashboard" onClick={goToDashboard} icon="pi pi-arrow-left" /></p>} modal className="p-fluid" onHide={() => setModelH(prev => prev = false)} maximized={true}>
                <ShowDocuments />
            </Dialog>} */}
        </>
    );
}